import { FormattedMessage } from 'react-intl';

export const FileTypesMarketing = {
  additional_materials: {
    label: (
      <FormattedMessage
        id="additionalMaterials"
        defaultMessage="Additional Materials"
      />
    ),
  },
  backgrounds: {
    label: (
      <FormattedMessage
        id="backgrounds"
        defaultMessage="Backgrounds"
      />
    ),
  },
  banners: {
    label: <FormattedMessage id="banners" defaultMessage="Banners" />,
  },
  characters: {
    label: (
      <FormattedMessage id="characters" defaultMessage="Characters" />
    ),
  },
  game_descriptions: {
    label: (
      <FormattedMessage
        id="gameDescriptions"
        defaultMessage="Game Descriptions"
      />
    ),
  },
  game_rules_translations: {
    label: (
      <FormattedMessage
        id="gameRulesTranslations"
        defaultMessage="Game Rules Translations"
      />
    ),
  },
  logo: {
    label: <FormattedMessage id="logo" defaultMessage="Logo" />,
  },
  presentation: {
    label: (
      <FormattedMessage id="presentation" defaultMessage="Presentation" />
    ),
  },
  presentations_no_branding: {
    label: (
      <FormattedMessage
        id="presentationsNoBranding"
        defaultMessage="Presentations No Branding"
      />
    ),
  },
  presentations_rubyplay_branding: {
    label: (
      <FormattedMessage
        id="presentationsRubyplayBranding"
        defaultMessage="Presentations Rubyplay Branding"
      />
    ),
  },
  screenshots: {
    label: (
      <FormattedMessage
        id="screenshots"
        defaultMessage="Screenshots"
      />
    ),
  },
  symbols: {
    label: <FormattedMessage id="symbols" defaultMessage="Symbols" />,
  },
  thumbnails: {
    label: (
      <FormattedMessage id="thumbnails" defaultMessage="Thumbnails" />
    ),
  },
  thumbnails_animated: {
    label: (
      <FormattedMessage
        id="thumbnailsAnimated"
        defaultMessage="Thumbnails Animated"
      />
    ),
  },
  video_trailers: {
    label: (
      <FormattedMessage
        id="videoTrailers"
        defaultMessage="Video Trailers"
      />
    ),
  },
};
